/*
 * Main App Component
 */

import React, { Component } from 'react';
import './App.css';

import MapContainer from "./components/MapContainer";
import RestaurantsList from "./components/RestaurantsList";
import Filter from "./components/Filter";
import AddRestaurant from "./components/AddRestaurant";
import {averageRatings, find} from "./components/lib";

var RESTAURANTS = [
   {
      "id":0,
      "restaurantName":"Bronco",
      "address":"39 Rue des Petites Écuries, 75010 Paris",
      "lat":36.246838,
      "long":1.324334,
      "isGooglePlaces":false,
      "ratings":[
         {
            "stars":4,
            "comment":"Great! But not many veggie options."
         },
         {
            "stars":5,
            "comment":"My favorite restaurant!"
         }
      ]
   },
   {
      "id":1,
      "restaurantName":"Babalou",
      "address":"4 Rue Lamarck, 75018 Paris",
      "lat":36.161267,
      "long":1.320087,
      "isGooglePlaces":false,
      "ratings":[
         {
            "stars":5,
            "comment":"Tiny pizzeria next to Sacre Coeur!"
         },
         {
            "stars":3,
            "comment":"Meh, it was fine."
         }
      ]
   },
   {     
     "id":2,
     "restaurantName":"Bueno",
     "address":"4 Rue Lamarck, 75018 Paris",
     "lat":36.161267,
     "long":1.336528,
     "isGooglePlaces":false,
     "ratings":[
        {
           "stars":2,
           "comment":"Tiny pizzeria next to Sacre Coeur!"
        },
        {
           "stars":2,
           "comment":"Meh, it was fine."
        }
     ]
   }
 ]

class App extends Component {
   constructor(props) {
      super(props);
      this.state = {
         min:0,
         max:5,
         restaurants: RESTAURANTS,
         currentPosition:'',
         displayAddRestaurantForm:false,
         newRestaurantLocation:{},
         displayGooglePlaces:true
      }
      this.handleFilter = this.handleFilter.bind(this);
      this.inRange = this.inRange.bind(this);
      this.handleAddReview = this.handleAddReview.bind(this);
      this.getUserPosition = this.getUserPosition.bind(this);
      this.handleDisplayAddRestaurant = this.handleDisplayAddRestaurant.bind(this);
      this.handleAddRestaurant = this.handleAddRestaurant.bind(this);
      this.fetchGooglePlaces = this.fetchGooglePlaces.bind(this);
      this.getGooglePlaces = this.getGooglePlaces.bind(this);
   }

   //save the user location
   getUserPosition(position){
      var pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }; 
      //find near restaurants
      this.fetchGooglePlaces(pos.lat,pos.lng);
      this.setState({currentPosition: pos})  
   }
  
   //get user location when app load
   componentDidMount(){
      if (navigator.geolocation) {
         navigator.geolocation.getCurrentPosition(
            position => this.getUserPosition(position)
         );
      } else {
         alert("Please enable device location, and restart.")
      }
   }

   //use Google Place api with nearbySearch
   fetchGooglePlaces(lat,lng){
      try {
         var service = new window.google.maps.places.PlacesService(document.getElementById('google-places')); // note that it removes the content inside div with tag '#service-helper'
         var currentLocation = new window.google.maps.LatLng(lat, lng);
         var request = {
            location: currentLocation,
            radius: '20000',
            type: ['restaurant']
         };
         service.nearbySearch(request, this.getGooglePlaces);
      }
      catch(err) {
         console.log("error google places api:"); 
         console.log(err.message);
      }
   }

   //push the google places restaurants to the restaurants list
   getGooglePlaces(results, status) {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          for (var i = 0; i < results.length; i++) {
              let jsonp = JSON.stringify(results[i]);
              let r = JSON.parse(jsonp);//read the google place json
              let ro = {};//restaurant object
              //convert google place to the restaurant format
              ro.id=r.id;
              ro.isGooglePlaces=true;
              ro.restaurantName=r.name;
              ro.rating=r.rating;
              ro.user_ratings_total=r.user_ratings_total;
              ro.address=r.vicinity;
              ro.lat=r.geometry.location.lat;
              ro.long=r.geometry.location.lng;
              ro.ratings=[{stars:r.rating, comment:''}]
              let restaurants = this.state.restaurants;
              restaurants.push(ro);
              this.setState({restaurants: restaurants});
          }
      }
      else {
         console.log("request status:");
         console.log(window.google.maps.places.PlacesServiceStatus);    
      }
  }
  
   //define if restaurant match the filter
   inRange(restaurant) {
      //the filter settings
      var min = this.state.min;
      var max = this.state.max;
      var toggleGP = this.state.displayGooglePlaces;
      //check the match of restaurant and the filter settings
      if(toggleGP===true){
         return ((averageRatings(restaurant) >= min)
                     &&(averageRatings(restaurant) <= max));
      }
      return ((averageRatings(restaurant) >= min)
         &&(averageRatings(restaurant) <= max)
         && (restaurant.isGooglePlaces===toggleGP));
   }
  
   //gettting the filter of the filterring form
   handleFilter(filterInput) {
      this.setState(filterInput);
   }
   
   //add new review to a restaurant
   handleAddReview(input) {
      this.setState((prevState) => {
         let restaurants = this.state.restaurants;
         let i = find(input.id, restaurants);
         restaurants[i].ratings.push({
                     "stars":input.rating,
                     "comment":input.review
                  });
         if(restaurants[i].isGooglePlaces) 
            restaurants[i].user_ratings_total++;
         return { restaurants };
      });
   }

   //display and hide the form to add new restaurant
   handleDisplayAddRestaurant = (input) => {
      this.setState((prevState) => {
         return {
            displayAddRestaurantForm: !prevState.displayAddRestaurantForm,
            newRestaurantLocation:input
         }
      });
   }

   //add new restaurant
   handleAddRestaurant(restaurant){
      restaurant.id = new Date().getTime();
      this.setState((prevState) => {
         let restaurants = prevState.restaurants;       
         restaurants.push(restaurant);
         return { displayAddRestaurantForm: !prevState.displayAddRestaurantForm,
                  restaurants };
       });
   }

  render() {
    return (
      <div className="App">
         <Filter onFilter={this.handleFilter}/>
			<MapContainer
            userPosition={this.state.currentPosition}
				restaurants={this.state.restaurants.filter(this.inRange)}
				loadingElement={<div style={{ height: `100%` }} />}
				containerElement={<div style={{ height: `100vh`, width: `100%` }} />}
				mapElement={<div style={{ height: `100%` }} />}
            onAddRestaurant={this.handleDisplayAddRestaurant}
			/>
         {
            this.state.displayAddRestaurantForm &&
            <AddRestaurant onAddRestaurant={this.handleAddRestaurant} location={this.state.newRestaurantLocation}  />
         }
         <RestaurantsList  
            restaurants={this.state.restaurants.filter(this.inRange)} 
            onAddReview={this.handleAddReview}
         />         
      </div>
    );
  }
}

export default App;
